import { isHttpUrl } from 'utils/urlUtils';

/**
 * Normalizes an endpoint that may come as an absolute URL into a relative path.
 * Useful to avoid CORS issues in dev when backend returns absolute URLs (different host).
 */
const normalizeUrlEndpoint = (maybeAbsoluteUrl: string): string => {
  const raw = (maybeAbsoluteUrl || '').trim();
  if (!raw) return raw;

  if (!isHttpUrl(raw)) {
    return raw;
  }

  try {
    const url = new URL(raw);
    return `${url.pathname}${url.search}`;
  } catch {
    return raw;
  }
};

export default normalizeUrlEndpoint;
